import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Util from '@/util'

Vue.use(VueAxios, axios)

const Api = {
  init () {
    this.axios = Vue.axios;
    this.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
    this.axios.defaults.withCredentials = false;
    this.axios.defaults.timeout = 15000;
    this.axios.defaults.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
  },

  request (params) {
    return new Promise((resolve, reject) => {
      const requestParams = Object.assign({}, params)
      if (!requestParams.method) {
        if (!Util.isEmpty(requestParams.data)) {
          requestParams.method = 'POST'
        } else {
          requestParams.method = 'GET'
        }
      }

      const sessionToken = localStorage.getItem('sessionToken');
      if (sessionToken) {
        requestParams.headers = Object.assign({}, requestParams.headers, {
          Authorization: sessionToken
        });
      }

      this.axios(requestParams).then((response) => {
        if (response.data.code) {
          reject(response.data)
        } else {
          resolve(response.data)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

export default Api
